module.exports = __webpack_public_path__ + "static/roboto-dc0e70b56064e93c66e4d46a49ba5870.png";